import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { CardContent } from "../../components/antd/card/CardContent";
import { SidecarEnvoyEditable } from "./sidecar/editable";

export const GvcSidecarEnvoy: React.FC = () => {
  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>Sidecar | Envoy</CardTitle>
        <CardContent>
          <SidecarEnvoyEditable />
        </CardContent>
      </Card>
    </div>
  );
};
